// src/store/modules/session.js
import axiosObject from '@ps_main/axios'

export default {
  namespaced: true,
  state: {
    lastCheckedAtIso: null
  },
  mutations: {
    SET_LAST_CHECKED_AT (state, iso) {
      state.lastCheckedAtIso = iso
    }
  },
  actions: {
    async checkSession ({ commit, rootGetters, dispatch }) {
      if (!rootGetters['auth/isLoggedIn']) return
      if (rootGetters['auth/pendingTwoFactorChallenge']) return

      try {
        const { data: adminData } = await axiosObject.get('/api/me')

        const isAdminRoleSuperAdmin = parseInt(adminData.role) === window.CONST_ADMIN_ROLE_SUPER_ADMIN
        const isValidModules =
            isAdminRoleSuperAdmin ||
            (Array.isArray(adminData.permissions?.modules) && adminData.permissions.modules.length > 0)

        if (isValidModules) {
          // Update both Vuex and LocalStorage
          commit('auth/UPDATE_ADMIN_INFO', adminData, { root: true })
          localStorage.setItem(window.CONST_LOCAL_STORAGE_KEY_ADMIN_INFO, JSON.stringify(adminData))
          commit('auth/REFRESH_MENU', null, { root: true })
        } else {
          // If they lost permissions while logged in, kick them out
          dispatch('auth/logout', null, { root: true })
        }

        return adminData // Return for the init action to use
      } catch (error) {
        if (error?.response?.status === 401) {
          dispatch('auth/logout', null, { root: true })
        }
        throw error
      }
    }
  }
}
